import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";

export const Driver = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const openEdit = (item) => setEditItem(item);
  const closeEdit = () => setEditItem(null);

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getDrivers();
      console.log(response);
      if (response?.success) {
        setData(response?.drivers || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const delteDriver = async (id) => {
    if (!window.confirm("Are you sure you want to delete this driver?")) return;
    try {
      const response = await api.deleteDrivers(id);
      console.log(response);
      if (response?.success) {
        notify.success("Driver deleted successfully!");
        getData();
      }
    } catch (error) {
      console.log(error);

      notify.error("Something went wrong!");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Drivers / Employees</h3>
            <Table data={data} delteDriver={delteDriver} openEdit={openEdit} />
          </div>
        </div>
        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>
      <CreateDriverModal show={show} handleClose={handleClose} getDrivers={getData} />
      {editItem && <EditDriverModal item={editItem} handleClose={closeEdit} getDrivers={getData} />}
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data, delteDriver, openEdit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleActiveImg = (link) => {
    setActiveImg(link);
    handleShowMore();
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Id Image
                </th>
                <th scope="col" className="">
                  Emp. ID
                </th>
                <th scope="col" className="">
                  Name
                </th>
                <th scope="col" className="">
                  Phone
                </th>
                <th scope="col" className="">
                  CNIC
                </th>
                <th scope="col" className="">
                  Address
                </th>
                <th scope="col" className="">
                  Salary
                </th>
                <th scope="col" className="">
                  Loans
                </th>
                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className=""></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    {item?.idImage ? (
                      <div
                        className="pImage"
                        style={{ maxWidth: 120, padding: 5 }}
                        onClick={() =>
                          handleActiveImg(
                            `${process.env.REACT_APP_SERVER_BASE_URL}/uploadedFiles/${item?.idImage}`,
                          )
                        }
                      >
                        <img
                          src={`${process.env.REACT_APP_SERVER_BASE_URL}/uploadedFiles/${item?.idImage}`}
                          alt=""
                        />
                      </div>
                    ) : (
                      <div className="text-center">-</div>
                    )}
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db" style={{ fontWeight: 600 }}>{item?.employeeId || "—"}</span>
                  </td>
                  <td scope="row">
                    <div className="table-text-dark" style={{ textTransform: "capitalize" }}>{item?.name}</div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">{item?.phone}</span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">{item?.cnic}</span>
                  </td>
                  <td>
                    <span className="table-text-dark db" style={{ textTransform: "capitalize" }}>{item?.address}</span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">Rs. {item?.salary}</span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.loans?.amount ? `Rs. ${item.loans.amount}` : "—"}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      display: "inline-block",
                      padding: "3px 10px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600,
                      textTransform: "capitalize",
                      background: item?.status === "active" ? "#d1fae5" : "#fee2e2",
                      color: item?.status === "active" ? "#065f46" : "#991b1b",
                    }}>
                      {item?.status || "—"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex gap-2 align-items-center">
                      <div className="edit p-2 cursor-pointer" onClick={() => openEdit(item)}>
                        <i className="fa-solid fa-pen-to-square"></i>
                      </div>
                      <div className="delete p-2 cursor-pointer" onClick={() => delteDriver(item?._id)}>
                        <i className="fa-solid fa-trash"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
          <Modal.Body>
            <div className="otpModalMain broadcastModal">
              <div className="closeIcon" onClick={handleCloseMore}>
                <i className="fa-solid fa-xmark" />
              </div>

              <div className="showMoreModalM">
                <div className="showMoreModal">
                  <img className="w-100" src={activeImg} alt="" />
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

const CreateDriverModal = ({ show, handleClose, getDrivers }) => {
  const [drivers, setDrivers] = useState([]);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    try {
      let payload = {
        name: data?.name,
        employeeId: data?.employeeId || "",
        phone: data?.phone,
        cnic: data?.cnic,
        address: data?.address,
        salary: data?.salary,
        idImage: data?.idImage || "",
      };
      console.log(payload);

      const response = await api.addDriver(payload);
      console.log(response);
      if (response?.success) {
        getDrivers();
        notify.success("Driver successfully added!");
        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const onFileChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      formData.append("image", e.target.files[0]);

      const uploadRes = await api.uploadFile(formData);
      console.log(uploadRes);
      setData({
        ...data,
        [e.target.name]: `${uploadRes?.fileName}`,
      });
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      console.log(e?.message || "Something went wrong");
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Add Driver</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Employee ID</label>
              <input
                type="text"
                name="employeeId"
                className="form-control"
                placeholder="e.g. EMP-001"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="number"
                name="phone"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>CNIC Number</label>
              <input
                type="text"
                name="cnic"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Address</label>
              <input
                type="text"
                name="address"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Salary</label>
              <input
                type="number"
                name="salary"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="uploadCard">
              <label>
                {data?.idImage ? (
                  "File Uploded"
                ) : (
                  <i className="fa-solid fa-plus"></i>
                )}
                <input
                  type="file"
                  name="idImage"
                  onChange={onFileChange}
                  accept="image/*"
                />
              </label>
              <div className="text-center">National ID</div>
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};
const EditDriverModal = ({ item, handleClose, getDrivers }) => {
  const [data, setData] = useState({
    name: item?.name || "",
    employeeId: item?.employeeId || "",
    phone: item?.phone || "",
    cnic: item?.cnic || "",
    address: item?.address || "",
    salary: item?.salary || "",
    idImage: item?.idImage || "",
  });
  const [loader, setLoader] = useState(false);
  const onTextChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const onFileChange = async (e) => {
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("image", e.target.files[0]);
      const uploadRes = await api.uploadFile(formData);
      setData({ ...data, [e.target.name]: uploadRes?.fileName });
    } catch (e) {
      alert("File upload failed");
    } finally {
      setLoader(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await api.updateDriver(item._id, data);
      if (response?.success) {
        getDrivers();
        notify.success("Driver updated successfully!");
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal show={true} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">Edit Driver</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Employee ID</label>
              <input type="text" name="employeeId" className="form-control" value={data?.employeeId} onChange={onTextChange} placeholder="e.g. EMP-001" />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" name="name" className="form-control" value={data?.name} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Phone Number</label>
              <input type="number" name="phone" className="form-control" value={data?.phone} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>CNIC Number</label>
              <input type="text" name="cnic" className="form-control" value={data?.cnic} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Address</label>
              <input type="text" name="address" className="form-control" value={data?.address} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Salary</label>
              <input type="number" name="salary" className="form-control" value={data?.salary} onChange={onTextChange} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="uploadCard">
              <label>
                {data?.idImage ? "File Uploaded" : <i className="fa-solid fa-plus"></i>}
                <input type="file" name="idImage" onChange={onFileChange} accept="image/*" />
              </label>
              <div className="text-center">National ID</div>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit} disabled={loader}>
            {loader ? "Uploading..." : "Update"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
